import App365Icon from "../empreenderUI/ui/appsIcons/365";
import ArtesanouIcon from "../empreenderUI/ui/appsIcons/ArtesanouIcon";
import ArtesanouIconBranco from "../empreenderUI/ui/appsIcons/ArtesanouIconBranco";
import AutoMagicoIcon from "../empreenderUI/ui/appsIcons/automagico";
import BotaoZapIcon from "../empreenderUI/ui/appsIcons/BotaoZap";
import SellyIcon from "../empreenderUI/ui/appsIcons/SellyIcon";
import CampoPersonalizadoIcon from "../empreenderUI/ui/appsIcons/CampoPersonalizadoIcon";
import ChegueiIcon from "../empreenderUI/ui/appsIcons/ChegueiIcon";
import CompreJuntoIcon from "../empreenderUI/ui/appsIcons/CompreJunto";
import DijitalIcon from "../empreenderUI/ui/appsIcons/Dijital";
import DropDigitalIcon from "../empreenderUI/ui/appsIcons/DropDigitalIcon";
import DropiIcon from "../empreenderUI/ui/appsIcons/DropiIcon";
import FreteHero from "../empreenderUI/ui/appsIcons/FreteHero";
import LilyIcon from "../empreenderUI/ui/appsIcons/LilyIcon";
import MelhorApp from "../empreenderUI/ui/appsIcons/MelhorApp";
import OvniIcon from "../empreenderUI/ui/appsIcons/OvniIcon";
import PromocaoAgendadaIcon from "../empreenderUI/ui/appsIcons/PromocaoAgendadaIcon";
import ReplayIcon from "../empreenderUI/ui/appsIcons/ReplayIcon";
import SakIcon from "../empreenderUI/ui/appsIcons/SakIcon";
import SuperCheckoutIcon from "../empreenderUI/ui/appsIcons/SuperCheckout";
import SuperFavoritoIcon from "../empreenderUI/ui/appsIcons/SuperFavoritoIcon";
import WidgetInstagramIcon from "../empreenderUI/ui/appsIcons/WidgetInstagramIcon";
import WidgetTikTokIcon from "../empreenderUI/ui/appsIcons/WidgetTikTokIcon";
import RastreioIcon from "../empreenderUI/ui/appsIcons/RastreioIcon";
import ParcelamentoIcon from "../empreenderUI/ui/appsIcons/ParcelamentoIcon";
import Boss from "../empreenderUI/ui/appsIcons/Boss";
import App365IconBranco from "../empreenderUI/ui/appsIcons/365Branco";
import AutoMagicoIconBranco from "../empreenderUI/ui/appsIcons/automagicoBranco";
import BotaoZapIconBranco from "../empreenderUI/ui/appsIcons/BotaoZapBranco";
import SellyIconBranco from "../empreenderUI/ui/appsIcons/SellyIconBranco";
import CampoPersonalizadoIconBranco from "../empreenderUI/ui/appsIcons/CampoPersonalizadoIconBranco";
import ChegueiIconBranco from "../empreenderUI/ui/appsIcons/ChegueiIconBranco";
import CompreJuntoIconBranco from "../empreenderUI/ui/appsIcons/CompreJuntoBranco";
import DijitalIconBranco from "../empreenderUI/ui/appsIcons/DijitalBranco";
import DropDigitalIconBranco from "../empreenderUI/ui/appsIcons/DropDigitalIconBranco";
import DropiIconBranco from "../empreenderUI/ui/appsIcons/DropiIconBranco";
import FreteHeroBranco from "../empreenderUI/ui/appsIcons/FreteHeroBranco";
import LilyIconBranco from "../empreenderUI/ui/appsIcons/LilyIconBranco";
import MelhorAppBranco from "../empreenderUI/ui/appsIcons/MelhorAppBranco";
import OvniIconBranco from "../empreenderUI/ui/appsIcons/OvniIconBranco";
import ParcelamentoIconBranco from "../empreenderUI/ui/appsIcons/ParcelamentoIconBranco";
import PromocaoAgendadaIconBranco from "../empreenderUI/ui/appsIcons/PromocaoAgendadaIconBranco";
import RastreioIconBranco from "../empreenderUI/ui/appsIcons/RastreioIconBranco";
import ReplayIconBranco from "../empreenderUI/ui/appsIcons/ReplayIconBranco";
import SakIconBranco from "../empreenderUI/ui/appsIcons/SakIconBranco";
import SuperCheckoutIconBranco from "../empreenderUI/ui/appsIcons/SuperCheckoutBranco";
import SuperFavoritoIconBranco from "../empreenderUI/ui/appsIcons/SuperFavoritoIconBranco";
import WidgetInstagramIconBranco from "../empreenderUI/ui/appsIcons/WidgetInstagramIconBranco";
import WidgetTikTokIconBranco from "../empreenderUI/ui/appsIcons/WidgetTikTokIconBranco";
import WhatslyIcon from "../empreenderUI/ui/appsIcons/WhatslyIcon";
import WhatslyIconBranco from "../empreenderUI/ui/appsIcons/WhatslyIconBranco";
import FeedxmlIcon from "../empreenderUI/ui/appsIcons/FeedxmlIcon";
import FeedxmlIconBranco from "../empreenderUI/ui/appsIcons/FeedxmlIconBranco";
import DashIcon from "../empreenderUI/ui/appsIcons/Dash";
import DashBrancoIcon from "../empreenderUI/ui/appsIcons/DashBranco";
import EmbaixadoresIcon from "../empreenderUI/ui/appsIcons/EmbaixadoresIcon";
import EmbaixadoresIconBranco from "../empreenderUI/ui/appsIcons/EmbaixadoresIconBranco";
import FreteNoProdutoIcon from "../empreenderUI/ui/appsIcons/FreteNoProdutoIcon";
import FreteNoProdutoIconBranco from "../empreenderUI/ui/appsIcons/FreteNoProdutoIconBranco";
import AreaDoClienteIcon from "../empreenderUI/ui/appsIcons/AreaDoClienteIcon";
import AreaDoClienteIconBranco from "../empreenderUI/ui/appsIcons/AreaDoClienteIconBranco";
import DescricaoProIcon from "../empreenderUI/ui/appsIcons/DescricaoProIcon";
import DescricaoProIconBranco from "../empreenderUI/ui/appsIcons/DescricaoProIconBranco";
import MontinkIcon from "../empreenderUI/ui/appsIcons/MontinkIcon";
import MontinkIconBranco from "../empreenderUI/ui/appsIcons/MontinkIconBranco";
import BuybuttonIcon from "../empreenderUI/ui/appsIcons/BuybuttonIcon";
import BuybuttonIconBranco from "../empreenderUI/ui/appsIcons/BuybuttonIconBranco";
import ShowtimeIcon from "../empreenderUI/ui/appsIcons/ShowtimeIcon";
import ShowtimeIconBranco from "../empreenderUI/ui/appsIcons/ShowtimeIconBranco";

export const EmpreenderApps = [
  {
    name: "365 Artes",
    namees: "365 Artes",
    eplus: "365ARTES",
    icon: <App365Icon />,
    iconwhite: <App365IconBranco />,
    tags: ["365artes", "365 artes", "365ARTES"],
    link: "https://365artes.com.br",
    content:
      "Um banco de artes para sua loja editáveis no Canva. Adicione selos nas fotos dos produtos",
    slug: "365artes",
    sluges: "365artes-latam",
    slugamigavel: "365artes",
  },
  {
    name: "Automágico",
    namees: "Automagico",
    eplus: "AUTOMAGICO",
    icon: <AutoMagicoIcon />,
    iconwhite: <AutoMagicoIconBranco />,
    tags: ["automagico", "auto mágico", "AUTOMAGICO"],
    link: "https://automagico.com.br",
    content:
      "Crie templates e cadastre produtos em massa a partir das fotos na sua loja",
    slug: "automagico",
    sluges: "automagico-latam",
    slugamigavel: "automagico",
  },
  {
    name: "Selly",
    namees: "Selly",
    eplus: "BRINDE",
    icon: <SellyIcon />,
    iconwhite: <SellyIconBranco />,
    tags: ["brinde no carrinho", "brinde", "BRINDE", "selly, SELLY"],
    link: "https://selly.com.br",
    content:
      "Aumente seu ticket médio e melhore a experiência do seu cliente oferecendo brindes",
    slug: "selly",
    sluges: "selly",
    slugamigavel: "selly",
  },
  {
    name: "Frete Hero",
    namees: "Flete Hero",
    eplus: "FRETEHERO",
    icon: <FreteHero />,
    iconwhite: <FreteHeroBranco />,
    tags: ["frete hero", "frete", "FRETEHERO"],
    link: "https://fretehero.com.br",
    content:
      "Defina um prazo adicional de frete para produtos personalizados, sob encomenda e multi-CD",
    slug: "fretehero",
    sluges: "fretehero-latam",
    slugamigavel: "frete-hero",
  },
  {
    name: "Botão Zap",
    namees: "Boton Zap",
    eplus: "BOTAOZAP",
    icon: <BotaoZapIcon />,
    iconwhite: <BotaoZapIconBranco />,
    tags: ["botão zap", "botaozap", "zap"],
    link: "https://empreender.plus/",
    content:
      "Inicie o suporte com uma mensagem padrão que carrega o link do produto que seu cliente está interessado",
    slug: "botaozap",
    sluges: "botonzap",
    slugamigavel: "botao-zap",
  },
  {
    name: "Campo Personalizado",
    namees: "Campo Personalizado",
    eplus: "PERSONALIZADO",
    icon: <CampoPersonalizadoIcon />,
    iconwhite: <CampoPersonalizadoIconBranco />,
    tags: ["campo personalizado", "campo", "PERSONALIZADO"],
    link: "https://campopersonalizado.com.br",
    content:
      "Adicione campos extras aos seus produtos, como texto, arquivo ou seleção para produtos personalizados",
    slug: "campopersonalizado",
    sluges: "campopersonalizado-latam",
    slugamigavel: "campo-personalizado",
  },
  {
    name: "Cheguei",
    namees: "Llegué",
    eplus: "CHEGUEI",
    icon: <ChegueiIcon />,
    iconwhite: <ChegueiIconBranco />,
    tags: ["cheguei", "CHEGUEI"],
    link: "https://cheguei.com.br",
    content:
      "Salve clientes interessados em produtos esgotados e os avise quando essas mercadorias voltarem",
    slug: "cheguei",
    sluges: "llegue-latam",
    slugamigavel: "cheguei",
  },
  {
    name: "Compre Junto",
    namees: "Compre Junto",
    eplus: "COMPREJUNTO",
    icon: <CompreJuntoIcon />,
    iconwhite: <CompreJuntoIconBranco />,
    tags: ["compre junto"],
    link: "https://empreender.plus",
    content:
      "Potencialize seu ticket médio com vendas de kits de produtos em uma unica transação",
    slug: "comprejunto",
    sluges: "comprejunto",
    slugamigavel: "compre-junto",
  },
  {
    name: "Dijital",
    namees: "Dijital",
    eplus: "DIJITAL",
    icon: <DijitalIcon />,
    iconwhite: <DijitalIconBranco />,
    tags: ["dijital", "digital", "DIJITAL"],
    link: "https://dijital.com.br",
    content:
      "Venda e-books, PDFs, MP3, MP4 e todo tipo de infoproduto na sua loja virtual",
    slug: "dijital",
    sluges: "dijital-latam",
    slugamigavel: "dijital",
  },
  {
    name: "Dropi",
    namees: "Dropi",
    eplus: "DROPI",
    icon: <DropiIcon />,
    iconwhite: <DropiIconBranco />,
    tags: ["dropi", "DROPI"],
    link: "https://dropi.com.br",
    content:
      "Venda produtos do mundo todo sem estoque com dropshipping internacional e nacional",
    slug: "dropi",
    sluges: "dropimx",
    slugamigavel: "dropi",
  },
  {
    name: "Drop.Digital",
    namees: "Drop.Digital",
    eplus: "DROPDIGITAL",
    icon: <DropDigitalIcon />,
    iconwhite: <DropDigitalIconBranco />,
    tags: ["drop.digital", "dropdigital", "drop digital", "DROPDIGITAL"],
    link: "https://dropdigital.com.br",
    content:
      "Importe infoprodutos como cursos e ebooks do seu nicho e venda sem estoque na sua loja",
    slug: "dropdigital",
    sluges: "dropdigital",
    slugamigavel: "dropdigital",
  },
  {
    name: "Empreender Plus",
    namees: "Empreender Plus",
    eplus: "PL",
    icon: <Boss />,
    iconwhite: <Boss />,
    tags: ["empreender plus", "EMPREENDERPLUS"],
    link: "https://empreender.plus/",
    content:
      "Importe infoprodutos como cursos e ebooks do seu nicho e venda sem estoque na sua loja",
    slug: "plus",
    sluges: "plus-latam",
    slugamigavel: "empreender-plus",
  },
  {
    name: "Landing Page",
    namees: "Landing Page",
    eplus: "LANDINGPAGE",
    icon: <MelhorApp />,
    iconwhite: <MelhorAppBranco />,
    tags: ["landingpage", "landing page", "LANDINGPAGE"],
    link: "https://landingpage.com.br/",
    content:
      "Construa páginas web sem precisar de código. Escolha um modelo pronto ou comece do zero",
    slug: "landingpage",
    sluges: "landingpage-latam",
    slugamigavel: "landing-page",
  },
  {
    name: "Lily Reviews",
    namees: "Lily Reviews",
    eplus: "LILY",
    icon: <LilyIcon />,
    iconwhite: <LilyIconBranco />,
    tags: ["lily review", "lily", "lily reviews", "LILY"],
    link: "https://lily.com.br",
    content:
      "Adicione avaliações em texto, foto ou vídeo, além de perguntas e respostas nos seus produtos",
    slug: "lilyreviews",
    sluges: "lily-latam",
    slugamigavel: "lily-reviews",
  },
  {
    name: "Ovni",
    namees: "Ovni",
    eplus: "OVNI",
    icon: <OvniIcon />,
    iconwhite: <OvniIconBranco />,
    tags: ["ovni", "OVNI"],
    link: "https://ovni.com.br/",
    content:
      "Crie campanhas e encontre o influenciador perfeito para seus produtos na rede social que preferir",
    slug: "suporteovni",
    sluges: "ovni-latam",
    slugamigavel: "ovni",
  },
  {
    name: "Parcelamento",
    namees: "Parcelamento",
    eplus: "PARC",
    icon: <ParcelamentoIcon />,
    iconwhite: <ParcelamentoIconBranco />,
    tags: ["parcelamento", "PARCELAMENTO"],
    link: "https://parcelamento.com/",
    content:
      "Crie campanhas e encontre o influenciador perfeito para seus produtos na rede social que preferir",
    slug: "parcelamento",
    sluges: "parcelamento",
    slugamigavel: "parcelamento",
  },
  {
    name: "Promoção agendada",
    namees: "Promo Agendada",
    eplus: "PROMOAGENDADA",
    icon: <PromocaoAgendadaIcon />,
    iconwhite: <PromocaoAgendadaIconBranco />,
    tags: ["promoção agendada", "promocao", "PROMOAGENDADA"],
    link: "https://empreender.plus",
    content:
      "Programe alterações de preço em massa e aumente suas vendas em datas comemorativas",
    slug: "promocaoagendada",
    sluges: "promoagendada",
    slugamigavel: "promocao-agendada",
  },
  {
    name: "Rastreio.net",
    namees: "Rastreio",
    eplus: "RASTREIO",
    icon: <RastreioIcon />,
    iconwhite: <RastreioIconBranco />,
    tags: ["RASTREIO", "rastreio"],
    link: "https://get.rastreio.net",
    content:
      "Adicione um vídeo flutuante à sua loja e mostre seus produtos na prática, oferecendo uma experiência visual envolvente",
    slug: "rastreio",
    sluges: "rastreio-latam",
    slugamigavel: "rastreio",
  },
  {
    name: "Replay",
    namees: "Replay",
    eplus: "RP",
    icon: <ReplayIcon />,
    iconwhite: <ReplayIconBranco />,
    tags: ["replay", "RP"],
    link: "https://empreender.plus/",
    content:
      "Adicione um vídeo flutuante à sua loja e mostre seus produtos na prática, oferecendo uma experiência visual envolvente",
    slug: "replay",
    sluges: "replay",
    slugamigavel: "replay",
  },
  {
    name: "Sak",
    namees: "Sak",
    eplus: "W",
    icon: <SakIcon />,
    iconwhite: <SakIconBranco />,
    tags: ["sak", "suporte", "atendimento", "W"],
    link: "https://get.sak.com.br",
    content:
      "Recupere carrinhos, boletos e PIX com automações de WhatsApp. Crie artigos FAQs e atenda com IA",
    slug: "suporte",
    sluges: "soporte",
    slugamigavel: "sak",
  },
  {
    name: "Super Checkout",
    namees: "Super Checkout",
    eplus: "SUPERNUVEM",
    icon: <SuperCheckoutIcon />,
    iconwhite: <SuperCheckoutIconBranco />,
    tags: ["super checkout", "checkout", "SuperCheckout", "SUPERNUVEM"],
    link: "https://www.supercheckout.com.br/",
    content:
      "Aumente a conversão com timer, recomendações de produtos, selos de autoridade e upsell no checkout.",
    slug: "supercheckout",
    sluges: "supercheckout",
    slugamigavel: "super-checkout",
  },
  {
    name: "Super Favoritos",
    namees: "Super Favoritos",
    eplus: "SUPERFAV",
    icon: <SuperFavoritoIcon />,
    iconwhite: <SuperFavoritoIconBranco />,
    tags: ["super favorito", "favorito", "SUPERFAV"],
    link: "https://empreender.plus/",
    content:
      "Aumente suas vendas com lista de desejos e histórico de navegação na sua loja",
    slug: "superfavoritos",
    sluges: "superfavoritos-latam",
    slugamigavel: "super-favoritos",
  },
  {
    name: "Whats.ly",
    namees: "Whats.ly",
    eplus: "WY",
    icon: <WhatslyIcon />,
    iconwhite: <WhatslyIconBranco />,
    tags: ["whatsly", "whats.ly", "WHATSLY", "WHATS.LY"],
    link: "https://widget.com.br",
    content:
      "O Whats.ly é uma ferramenta para quem quer vender usando grupos de WhatsApp. Quanto mais potenciais clientes você tiver dentro dos grupos de WhatsApp, maior será a sua renda.",
    slug: "whatsly",
    sluges: "whatsly-latam",
    slugamigavel: "whatsly",
  },
  {
    name: "Widget Instagram",
    namees: "Widget Instagram",
    eplus: "WIDGETINSTA",
    icon: <WidgetInstagramIcon />,
    iconwhite: <WidgetInstagramIconBranco />,
    tags: ["widget instagram", "instagram", "social", "WIDGETINSTA"],
    link: "https://widget.com.br",
    content:
      "Adicione o feed do Instagram na sua loja. Marque produtos e leve o cliente para o checkout",
    slug: "widget",
    sluges: "widget-latam",
    slugamigavel: "widget-instagram",
  },
  {
    name: "Widget TikTok",
    namees: "Widget TikTok",
    eplus: "WIDGETTIK",
    icon: <WidgetTikTokIcon />,
    iconwhite: <WidgetTikTokIconBranco />,
    tags: ["widget tiktok", "tiktok", "social", "WIDGETTIK"],
    link: "https://widget.com.br",
    content:
      "Adicione vídeos do TikTok na sua loja. Marque produtos e leve o cliente para o checkout",
    slug: "widget",
    sluges: "widget-latam",
    slugamigavel: "widget-tiktok",
  },
  {
    name: "Suporte Empreender",
    namees: "Soporte Empreender",
    eplus: "SUPORTEEMPREENDER",
    icon: <Boss />,
    iconwhite: <Boss />,
    tags: ["suporte empreender", "SUPORTEEMPREENDER"],
    link: "#",
    content: "Tire suas dúvidas sobre todos os apps da Empreender",
    slug: "suporte-empreender",
    sluges: "suporte-empreender",
    slugamigavel: "suporte-empreender",
  },
  {
    name: "FeedXML",
    namees: "FeedXML",
    eplus: "FEEdXML",
    icon: <FeedxmlIcon />,
    iconwhite: <FeedxmlIconBranco />,
    tags: ["FeedXML", "FEEdXML"],
    link: "https://www.nuvemshop.com.br/loja-aplicativos-nuvem/feed-xml",
    content:
      "O Feed XML serve para você ter acesso ao link XML com o catálogo dos seus produtos, e assim, melhorar suas campanhas de tráfego pago.",
    slug: "feedxml",
    sluges: "feedxml-latam",
    slugamigavel: "feedxml",
  },
  {
    name: "Dash",
    namees: "Dash",
    eplus: "DASH",
    icon: <DashIcon />,
    iconwhite: <DashBrancoIcon />,
    tags: ["dash", "DASH"],
    link: "https://app.dash.com.br/",
    content: "Tire suas dúvidas sobre todos os apps da Empreender",
    slug: "appdashboard",
    sluges: "appdashboard",
    slugamigavel: "dash",
  },
  {
    name: "Embaixadores",
    namees: "Embaixadores",
    eplus: "EMBAIXADORES",
    icon: <EmbaixadoresIcon />,
    iconwhite: <EmbaixadoresIconBranco />,
    tags: ["embaixadores", "EMBAIXADORES"],
    link: "https://embaixadores.com.br/",
    content: "Ganhe dinheiro com os apps da Empreender",
    slug: "embaixadores",
    sluges: "embaixadores",
    slugamigavel: "embaixadores",
  },
  {
    name: "Frete no Produto",
    namees: "Frete no Produto",
    eplus: "FRETEPRODUTO",
    icon: <FreteNoProdutoIcon />,
    iconwhite: <FreteNoProdutoIconBranco />,
    tags: ["embaixadores", "EMBAIXADORES"],
    link: "https://embaixadores.com.br/",
    content: "Ganhe dinheiro com os apps da Empreender",
    slug: "suportefretenoproduto",
    sluges: "suportefretenoproduto",
    slugamigavel: "suportefretenoproduto",
  },
  {
    name: "Descrição Pro",
    namees: "Descrição Pro",
    eplus: "DESCRICAOPRO",
    icon: <DescricaoProIcon />,
    iconwhite: <DescricaoProIconBranco />,
    tags: ["descrição pro", "DESCRIÇÃO PRO"],
    link: "https://app.descricaopro.com.br",
    content: "Ganhe dinheiro com os apps da Empreender",
    slug: "descricaopro",
    sluges: "descricaopro",
    slugamigavel: "descricaopro",
  },
  {
    name: "Área do Cliente",
    namees: "Área do Cliente",
    eplus: "AREADOCLIENTE",
    icon: <AreaDoClienteIcon />,
    iconwhite: <AreaDoClienteIconBranco />,
    tags: ["área do cliente", "AREA DO CLIENTE"],
    link: "https://app.areadocliente.com.br",
    content: "Ganhe dinheiro com os apps da Empreender",
    slug: "areadocliente",
    sluges: "areadocliente",
    slugamigavel: "areadocliente",
  },
  {
    name: "Montink",
    namees: "Montink",
    eplus: "MONTINK",
    icon: <MontinkIcon />,
    iconwhite: <MontinkIconBranco />,
    tags: ["montink", "MONTINK"],
    link: "https://montink.com",
    content: "Ganhe dinheiro com os apps da Empreender",
    // Slug da central na SAK (montink.sak.com.br). "montinkajuda" não existe lá e voltava vazio.
    slug: "montink",
    sluges: "montink",
    slugamigavel: "montinkajuda",
  },
  {
    name: "BuyButton",
    namees: "BuyButton",
    eplus: "BUYBUTTON",
    icon: <BuybuttonIcon />,
    iconwhite: <BuybuttonIconBranco />,
    tags: ["buybutton", "BUYBUTTON"],
    link: "https://montink.com",
    content: "Ganhe dinheiro com os apps da Empreender",
    slug: "suportebuybutton",
    sluges: "suportebuybutton",
    slugamigavel: "suportebuybutton",
  },
  {
    name: "Showtime",
    namees: "Showtime",
    eplus: "SHOWTIME",
    icon: <ShowtimeIcon />,
    iconwhite: <ShowtimeIconBranco />,
    tags: ["showtime", "SHOWTIME"],
    link: "https://showtime.com.br",
    content: "Ganhe dinheiro com os apps da Empreender",
    slug: "suporteshowtime",
    sluges: "suporteshowtime",
    slugamigavel: "suporteshowtime",
  },
  {
    // Central na SAK: suporteartesanou (lista Bot/faqsEmpreender da SAK); ícone do Brandox da Empreender.
    name: "Artesanou",
    namees: "Artesanou",
    eplus: "ARTESANOU",
    icon: <ArtesanouIcon />,
    iconwhite: <ArtesanouIconBranco />,
    tags: ["artesanou", "artesanato", "marketplace de artesanato", "ARTESANOU"],
    link: "https://artesanou.com.br",
    content: "Marketplace de artesanato brasileiro: venda suas peças para clientes de todo o Brasil",
    slug: "suporteartesanou",
    sluges: "suporteartesanou",
    slugamigavel: "artesanou",
  }
];
